<template>
  <customModal
    :containersm="true"
    @closeModal="$emit('closeModal')"
  >
    <template #title>
      <span style="display:flex; align-items:center; gap:8px;">
        <i class="fa fa-upload "></i>
        {{ $t("navigations.import excel") }}
      </span>
    </template>
    <template #body>
      <!-- Drop Zone -->
      <div
        class="drop-zone"
        @dragover.prevent="isDragging = true"
        @dragleave="isDragging = false"
        @drop.prevent="handleDrop"
        :class="{ 'drag-active': isDragging }"
      >
        <p class="drop-title">{{$t("navigations.drop your excel file here")}}</p>
        <p class="drop-supported">{{$t("navigations.supported format")}} .xlsx, .xls</p>

        <!-- Browse Files Button -->
        <button
          type="button"
          class="btn btn-primary btn-sm py-0"
          style="font-size: 12px;"
          @click.stop="$refs.fileInput.click()"
        >
          <i class="fa fa-folder mr-1"></i>
         {{$t("navigations.browse files") }}
        </button>

        <!-- Selected file display -->
        <p v-if="selectedFile" class="drop-filename">
          <i class="fa fa-file-excel-o mr-1"></i>{{ selectedFile.name }}
          &nbsp;({{ (selectedFile.size / 1024 / 1024).toFixed(2) }} MB)
        </p>

        <span class="errorClass text-danger d-block mt-1" v-if="fileError">
          {{ $t("navigations.please select a valid excel file") }}
        </span>

        <input
          type="file"
          ref="fileInput"
          accept=".xlsx,.xls"
          style="display:none"
          @change="handleFileChange"
        />
      </div>

      <!-- Footer info bar -->
      <div class="footer-info-bar">
        <div>
          <small><strong>{{$t("navigations.supported format") }}:</strong> .xlsx, .xls</small>
        </div>
        <div class="" @click="downloadImportTemplate">
          <small>
            {{ $t("navigations.upload the template and follow the format") }}
            <i class="fa fa-upload ml-1"></i>
          </small>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="footer-actions">
        <button
          type="button"
          class="btn btn-outline-secondary me-2 btn-sm py-0" style="font-size: 12px;"
          @click="$emit('closeModal')"
        >
          <i class="fa fa-close mr-1"></i>
          {{ $t("navigations.cancel") }}
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm position-relative py-0"
          style="font-size: 12px;"
          :disabled="isLoading || !selectedFile"
          :class="{ 'disabled-btn-cls': isLoading || !selectedFile }"
          @click="uploadExcel"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': !isLoading,
              'opacity-1': isLoading,
            }"
          >
            <img src="../../assets/img/loading.gif" width="14" alt="loading" />
          </div>
          <div :class="{ 'opacity-1': !isLoading, 'opacity-0': isLoading }">
            <i class="fa fa-upload"></i>
            {{ $t("navigations.import excel") }}
          </div>
        </button>
      </div>
    </template>
  </customModal>
</template>

<script src="./tocexcel.js"></script>

<style scoped>
/* ── Drop Zone ── */
.drop-zone {
  border: 2.5px dashed #5b9bd5;
  border-radius: 6px;
  background: #f7faff;
  padding: 30px 30px;
  text-align: center;
  cursor: default;
  transition: border-color 0.2s, background 0.2s;
  margin: 8px 12px 0;
}
.drop-zone:hover,
.drag-active {
  border-color: #185FA5 !important;
  background: #e8f0fb !important;
}

.drop-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0 0 4px;
}

.drop-supported {
  font-size: 13px;
  color: #888;
  margin: 0 0 14px;
}

/* Browse Files button */
/* .browse-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #4a90d9;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 5px 16px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
} */
.browse-btn:hover {
  background: #3a7bc8;
}
.browse-btn i {
  font-size: 13px;
}

.drop-filename {
  font-size: 11px;
  color: #014201;
  font-weight: 500;
  margin-top: 12px;
  margin-bottom: 0;
}

/* ── Footer info bar ── */
.footer-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  /* border-top: 1px solid #e8e8e8; */
  padding: 10px 14px;
  margin: 1px 0 0;
}
.footer-info-bar small {
  color: #555;
}
.footer-info-bar .cursor-pointer:hover small {
  color: #185FA5;
  text-decoration: underline;
}

/* ── Footer action buttons ── */
.footer-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1px;
  padding: 4px 14px 0;
}

.btn-cancel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #fff;
  color: #555;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px 14px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.15s;
}
.btn-cancel:hover {
  background: #f0f0f0;
}

.btn-import {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #4a90d9;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 5px 16px;
  font-size: 13px;
  cursor: pointer;
  position: relative;
  transition: background 0.15s;
}
.btn-import:hover:not(:disabled) {
  background: #3a7bc8;
}

/* ── Utilities ── */
.disabled-btn-cls {
  opacity: 0.6;
  pointer-events: none;
}
.opacity-0 { opacity: 0; }
.opacity-1 { opacity: 1; }
.cursor-pointer { cursor: pointer; }

.errorClass {
  color: #e03e2d;
  font-size: 0.875rem;
}
</style>